function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L36 0L36 36L0 36L0 0Z",
  id: "calculator_path"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "calculator_mask"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calculator_path"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "calculator-(2)-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L36 0L36 36L0 36L0 0Z",
  id: "calculator-(2)-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calculator_mask)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.6797 32.625C24.6797 33.2072 24.2072 33.6797 23.625 33.6797L1.05469 33.6797C0.4725 33.6797 0 33.2072 0 32.625L0 1.05469C0 0.4725 0.4725 0 1.05469 0L23.625 0C24.2072 0 24.6797 0.4725 24.6797 1.05469L24.6797 32.625Z",
  id: "Vector",
  fill: "#526AF1",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.3047 32.625C12.3047 33.2072 11.8322 33.6797 11.25 33.6797L0 33.6797L0 0L11.25 0C11.8322 0 12.3047 0.4725 12.3047 1.05469L12.3047 32.625Z",
  transform: "translate(12.375 0)",
  id: "Vector",
  fill: "#2F42B0",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.6094 6.67969C15.6094 7.26188 15.1369 7.73438 14.5547 7.73438L1.05469 7.73438C0.4725 7.73438 0 7.26188 0 6.67969L0 1.05469C0 0.4725 0.4725 0 1.05469 0L14.5547 0C15.1369 0 15.6094 0.4725 15.6094 1.05469L15.6094 6.67969Z",
  transform: "translate(4.5703125 4.5703125)",
  id: "Vector",
  fill: "#F6F9F9",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.80469 6.67969C7.80469 7.26188 7.33219 7.73438 6.75 7.73438L0 7.73438L0 0L6.75 0C7.33219 0 7.80469 0.4725 7.80469 1.05469L7.80469 6.67969Z",
  transform: "translate(12.375 4.5703125)",
  id: "Vector",
  fill: "#E2DFF4",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.17969 2.10938L1.05469 2.10938C0.4725 2.10938 0 1.63687 0 1.05469C0 0.4725 0.4725 0 1.05469 0L2.17969 0C2.76187 0 3.23438 0.4725 3.23438 1.05469C3.23438 1.63687 2.76187 2.10938 2.17969 2.10938Z",
  transform: "translate(10.7578125 14.6953125)",
  id: "Vector",
  fill: "#3A4AAF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 2.10938L0 0L0.5625 0C1.14469 0 1.61719 0.4725 1.61719 1.05469C1.61719 1.63687 1.14469 2.10938 0.5625 2.10938L0 2.10938Z",
  transform: "translate(12.375 14.6953125)",
  id: "Vector",
  fill: "#3340D8",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.17969 2.10938L1.05469 2.10938C0.4725 2.10938 0 1.63687 0 1.05469C0 0.4725 0.4725 0 1.05469 0L2.17969 0C2.76187 0 3.23438 0.4725 3.23438 1.05469C3.23438 1.63687 2.76187 2.10938 2.17969 2.10938Z",
  transform: "translate(10.7578125 20.320312)",
  id: "Vector",
  fill: "#3A4AAF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.5625 2.10938L0 2.10938L0 0L0.5625 0C1.14469 0 1.61719 0.4725 1.61719 1.05469C1.61719 1.63687 1.14469 2.10938 0.5625 2.10938Z",
  transform: "translate(12.375 20.320312)",
  id: "Vector",
  fill: "#3340D8",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.17969 2.10938L1.05469 2.10938C0.4725 2.10938 0 1.63687 0 1.05469C0 0.4725 0.4725 0 1.05469 0L2.17969 0C2.76187 0 3.23438 0.4725 3.23438 1.05469C3.23438 1.63687 2.76187 2.10938 2.17969 2.10938Z",
  transform: "translate(10.7578125 25.945312)",
  id: "Vector",
  fill: "#3A4AAF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.5625 2.10938L0 2.10938L0 0L0.5625 0C1.14469 0 1.61719 0.4725 1.61719 1.05469C1.61719 1.63687 1.14469 2.10938 0.5625 2.10938Z",
  transform: "translate(12.375 25.945312)",
  id: "Vector",
  fill: "#3340D8",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.05469 2.10938C0.472219 2.10938 0 1.63716 0 1.05469C0 0.472219 0.472219 0 1.05469 0L2.17969 0C2.76216 0 3.23438 0.472219 3.23438 1.05469C3.23438 1.63716 2.76216 2.10938 2.17969 2.10938L1.05469 2.10938Z",
  transform: "translate(5.1328125 14.6953125)",
  id: "Vector",
  fill: "#3A4AAF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.05469 2.10938C0.472219 2.10938 0 1.63716 0 1.05469C0 0.472219 0.472219 0 1.05469 0L2.17969 0C2.76216 0 3.23438 0.472219 3.23438 1.05469C3.23438 1.63716 2.76216 2.10938 2.17969 2.10938L1.05469 2.10938Z",
  transform: "translate(5.1328125 20.320312)",
  id: "Vector",
  fill: "#3A4AAF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.05469 2.10938C0.472219 2.10938 0 1.63716 0 1.05469C0 0.472219 0.472219 0 1.05469 0L2.17969 0C2.76216 0 3.23438 0.472219 3.23438 1.05469C3.23438 1.63716 2.76216 2.10938 2.17969 2.10938L1.05469 2.10938Z",
  transform: "translate(5.1328125 25.945312)",
  id: "Vector",
  fill: "#ACE233",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.05469 2.10938C0.472219 2.10938 0 1.63716 0 1.05469C0 0.472219 0.472219 0 1.05469 0L2.17969 0C2.76216 0 3.23438 0.472219 3.23438 1.05469C3.23438 1.63716 2.76216 2.10938 2.17969 2.10938L1.05469 2.10938Z",
  transform: "translate(16.382812 14.6953125)",
  id: "Vector",
  fill: "#3340D8",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 18.0703C4.02961 18.0703 0 13.9704 0 9C0 4.02961 4.02961 0 9 0C13.9704 0 18.0703 4.02961 18.0703 9C18.0703 13.9704 13.9704 18.0703 9 18.0703Z",
  transform: "translate(16.875 16.875)",
  id: "Vector",
  fill: "#FFE278",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 18.0703L0 0C4.97039 0 9.07031 4.02961 9.07031 9C9.07031 13.9704 4.97039 18.0703 0 18.0703Z",
  transform: "translate(25.875 16.875)",
  id: "Vector",
  fill: "#FFB454",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 10.0547C0 15.5988 4.51055 20.1797 10.0547 20.1797C15.5988 20.1797 20.1797 15.5988 20.1797 10.0547C20.1797 4.51055 15.5988 0 10.0547 0C4.51055 0 0 4.51055 0 10.0547ZM2.10938 10.0547C2.10938 5.67352 5.67352 2.10938 10.0547 2.10938C14.4359 2.10938 18.0703 5.67352 18.0703 10.0547C18.0703 14.4359 14.4359 18.0703 10.0547 18.0703C5.67352 18.0703 2.10938 14.4359 2.10938 10.0547Z",
  transform: "translate(15.8203125 15.8203125)",
  id: "Vector",
  fill: "#FFD300",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 20.1797L0 18.0703C4.38117 18.0703 8.01563 14.4359 8.01563 10.0547C8.01563 5.67352 4.38117 2.10938 0 2.10938L0 0C5.54414 0 10.125 4.51055 10.125 10.0547C10.125 15.5988 5.54414 20.1797 0 20.1797Z",
  transform: "translate(25.875 15.8203125)",
  id: "Vector",
  fill: "#E2BB03",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.07748 10.6277C4.07748 11.1945 3.63029 11.6571 3.0692 11.681C3.05373 11.6824 3.03896 11.6824 3.02349 11.6824L3.02279 11.6824C2.4406 11.6824 1.9681 11.2099 1.9681 10.6277L1.9681 10.5265C1.48224 10.4414 1.03787 10.2593 0.47748 9.89227C-0.00978503 9.57375 -0.146894 8.91984 0.172325 8.43258C0.49084 7.94531 1.14474 7.8082 1.63201 8.12742C2.17974 8.48531 2.34428 8.48531 3.02139 8.48531L3.02349 8.48531C3.03896 8.48531 3.05443 8.48461 3.0692 8.48391C3.70834 8.45227 3.96568 7.93969 4.01701 7.63453C4.06482 7.35258 4.01138 6.97711 3.48896 6.79289C3.35256 6.74437 3.21193 6.69305 3.0692 6.63961C3.05373 6.63398 3.03896 6.62836 3.02349 6.62274C2.34428 6.3675 1.62076 6.05461 1.07865 5.62992C-0.369786 4.49297 0.0675573 1.89773 1.9681 1.20726L1.9681 1.05469C1.9681 0.4725 2.4406 9.23262e-13 3.02279 9.23262e-13L3.02349 9.23262e-13C3.03896 9.23262e-13 3.05373 -7.72445e-07 3.0692 0.00140548C3.63029 0.0253117 4.07748 0.487969 4.07748 1.05469L4.07748 1.11375C4.59709 1.26 5.01545 1.52508 5.30303 1.81828C5.71154 2.23242 5.70591 2.90039 5.29037 3.30961C4.87552 3.71813 4.20826 3.7118 3.79975 3.29766C3.75193 3.25055 3.52834 3.06422 3.0692 3.10781C3.05443 3.10922 3.03896 3.11133 3.02349 3.11344L3.02139 3.11344C2.92787 3.12539 2.82521 3.14648 2.71271 3.18094C2.43217 3.26531 2.35623 3.55711 2.34006 3.6443C2.3056 3.8257 2.35482 3.94875 2.38084 3.96914C2.54678 4.09922 2.77529 4.22578 3.02349 4.3425C3.03896 4.35023 3.05373 4.35727 3.0692 4.3643C3.45592 4.54149 3.88271 4.69477 4.19209 4.80445C6.97154 5.78742 6.63263 9.48375 4.07748 10.4077L4.07748 10.4077L4.07748 10.6277Z",
  transform: "translate(22.851562 20.043945)",
  id: "Vector",
  fill: "#FFB454",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(25.875 20.043945)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.05398 6.28523C1.05398 6.85195 0.606797 7.31461 0.0457027 7.33852C0.030234 7.33992 0.0154688 7.33992 0 7.33992L0 4.14281C0.0154688 4.14281 0.0309371 4.14211 0.0457027 4.14141C0.684843 4.10977 0.942188 3.59719 0.993516 3.29203C1.04133 3.01008 0.98789 2.63461 0.465469 2.45039C0.329062 2.40188 0.188437 2.35055 0.0457027 2.29711C0.030234 2.29149 0.0154688 2.28586 0 2.28024L0 0C0.0154688 0.00773437 0.030234 0.0147676 0.0457027 0.0217988C0.432422 0.198986 0.859219 0.352266 1.16859 0.461954C3.94805 1.44492 3.60914 5.14125 1.05398 6.06516L1.05398 6.06516L1.05398 6.28523Z",
  transform: "translate(0 4.3425293)",
  id: "Vector",
  fill: "#FF7D47",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 3.11343L0 9.2326e-13C0.0154687 9.2326e-13 0.0302339 -7.72444e-07 0.0457027 0.00140548C0.606796 0.0253117 1.05398 0.487968 1.05398 1.05469L1.05398 1.11375C1.57359 1.26 1.99195 1.52508 2.27953 1.81828C2.68805 2.23242 2.68242 2.90039 2.26687 3.30961C1.85203 3.71812 1.18477 3.71179 0.77625 3.29765C0.728438 3.25054 0.504843 3.06421 0.0457027 3.10781L0.0457027 3.10781C0.0309371 3.10921 0.0154687 3.11133 0 3.11343Z",
  id: "Vector",
  fill: "#FF7D47",
  fillRule: "evenodd",
  stroke: "none"
})))));

var SvgCalculator = function SvgCalculator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalculator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calculator.33955053.svg";
export { ForwardRef as ReactComponent };